import React, { useState, useEffect } from 'react';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box } from '@mui/material';
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";

function CurrentMonthData() {
  const [data, setData] = useState([]);
  const [currentMonthData, setCurrentMonthData] = useState([]);
  const [currentMonthTotal, setCurrentMonthTotal] = useState(0);
  const userEmail = localStorage.getItem('UserEmail') || '';
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application/details`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
      body: JSON.stringify({ userEmail })
    })
      .then(response => response.json())
      .then(data => {

        // Filter only 'APPROVED' applications
        const approvedData = data.filter(item => item.ApplicationStatus === 'APPROVED');
        setData(approvedData);

        const currentMonth = new Date().getMonth() + 1; // 1-based
        const currentYear = new Date().getFullYear();

        const filteredCurrentMonthData = approvedData.filter(item => {
          const itemDate = new Date(item.startingdate.replace(/-/g, '/')); // Fix date parsing
          return itemDate.getMonth() + 1 === currentMonth && itemDate.getFullYear() === currentYear;
        });

        setCurrentMonthData(filteredCurrentMonthData);

        // Calculate total leave days for current month
        const totalDays = filteredCurrentMonthData.reduce((total, item) => total + item.noofdays, 0);
        setCurrentMonthTotal(totalDays);
      })
      .catch(error => console.error("Fetch error:", error));
  }, [userEmail]);

  const columns = [
    { field: 'id', headerName: 'ID', flex: 1 },
    { field: 'leavetype', headerName: 'Leave Type', flex: 1 },
    { field: 'startingdate', headerName: 'Start Date', flex: 1 },
    { field: 'endingdate', headerName: 'End Date', flex: 1 },
    { field: 'ApplyingDate', headerName: 'Apply Date', flex: 1 },
    { field: 'ApplicationStatus', headerName: 'Status', flex: 1 },
    { field: 'noofdays', headerName: 'No Of Days', flex: 1 },
  ];

  const currentMonthRows = currentMonthData.map(item => ({
    id: item.applicationno,
    leavetype: item.leavetype,
    startingdate: item.startingdate,
    endingdate: item.endingdate,
    ApplyingDate: item.ApplyingDate,
    ApplicationStatus: item.ApplicationStatus,
    noofdays: item.noofdays,
  }));


  return (
    <Box m="20px">
      <Header title="CURRENT MONTH DATA" />
      <Box m="40px 0 0 0" height="75vh" sx={{
        "& .MuiDataGrid-root": { border: "none" },
        "& .MuiDataGrid-cell": { borderBottom: "none" },
        "& .MuiDataGrid-columnHeaders": { backgroundColor: colors.blueAccent[700], borderBottom: "none" },
        "& .MuiDataGrid-virtualScroller": { backgroundColor: colors.primary[400] },
        "& .MuiDataGrid-footerContainer": { borderTop: "none", backgroundColor: colors.blueAccent[700] },
        "& .MuiCheckbox-root": { color: `${colors.greenAccent[200]} !important` },
        "& .MuiDataGrid-toolbarContainer .MuiButton-text": { color: `${colors.grey[100]} !important` },
      }}>
        <h2>Current Month Total: {currentMonthTotal}</h2>
        <DataGrid
          rows={currentMonthRows}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
          pagination
          pageSize={10}
          rowsPerPageOptions={[10, 25, 50]}
          checkboxSelection
          autoHeight
          hideFooterSelectedRowCount
        />
      </Box>
    </Box>
  );
}

export default CurrentMonthData;
